import React from "react";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import SearchList from "./SearchList";

export default class Search extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      q: "",
    };
  }
  init() {
    const searchParams = new URLSearchParams(document.location.search);
    this.setState({ q: searchParams.get("q") });
  }

  componentDidMount() {
    this.init();
  }

  render() {
    return (
      <>
        <CrumbsProvider title="Поиск" />
        <div className="container">
          <SearchList query={this.state.q} />
        </div>
      </>
    );
  }
}
